import t from "./ghl-ui.es1235.js";
import a from "./ghl-ui.es728.js";
var o = t(a, "DataView");
const i = o;
export {
  i as default
};
